import { AlertTriangle } from "lucide-react";
import { useCallback, useEffect, useRef, useState } from "react";
import { Navigate } from "react-router-dom";
import { fetchCostosUnificado } from "../api";
import { CostosView } from "../components/costos/CostosView";
import { LoadingState } from "../components/LoadingState";
import { CostosMobile } from "../components/costos/mobile/CostosMobile";
import { useIsMobile } from "../components/social/mobile/MobileChrome";
import { useDocumentTheme } from "../components/social/useDocumentTheme";
import { useDashboard } from "../context/DashboardContext";
import type { CostosUnificado } from "../types";
import "../components/social/sandbox/sandbox.css";
import "../components/social/mobile/mobile.css";
import "../components/costos/costos.css";
import "../components/costos/mobile/costosMobile.css";

export function CostosPage() {
  const { session } = useDashboard();
  const theme = useDocumentTheme();
  const mobile = useIsMobile();
  const [data, setData] = useState<CostosUnificado | null>(null);
  const [error, setError] = useState<string | null>(null);
  const ultimaCarga = useRef(0);

  const load = useCallback(async () => {
    const carga = ++ultimaCarga.current;
    try {
      const respuesta = await fetchCostosUnificado(4);
      if (carga === ultimaCarga.current) { setData(respuesta); setError(null); }
    } catch (err: any) {
      if (carga === ultimaCarga.current) setError(err?.message || "No se pudieron cargar los costos.");
    }
  }, []);

  useEffect(() => { void load(); }, [load]);

  if (session && !session.canViewCosts) return <Navigate to="/" replace />;

  return (
    <div className="page enter">
      {error && (
        <div className="panel" style={{ border: "1px solid var(--red)", color: "var(--red)", padding: "0.9rem 1.25rem", display: "flex", alignItems: "center", gap: "0.6rem" }}>
          <AlertTriangle size={18} /> <span>{error}</span>
        </div>
      )}
      {!data && !error && <LoadingState />}
      {data && (mobile ? <CostosMobile data={data} theme={theme} onReload={load} /> : <CostosView data={data} theme={theme} onReload={load} />)}
    </div>
  );
}
